module.exports = __webpack_public_path__ + "static/media/yoga-active.ecd1f75b.png";